import { render, staticRenderFns } from "./Kelquartier.vue?vue&type=template&id=5d509805&scoped=true"
import script from "./Kelquartier.vue?vue&type=script&lang=js"
export * from "./Kelquartier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d509805",
  null
  
)

export default component.exports